/** For concatenating GraphQL queries */

const _stringifyBool = (value) => value ? `true` : `false`;
const _stringifyEnum = (object) => object.value;
const _stringifyNumber = (value) => `${String(value)}`;
const _stringifyString = (value) => `"${String(value)}"`;
const _stringifyUndefined = () => ``;

let _recurseStringify;
const _stringifyArray = (array) => {
  let concat = `[`;
  concat += array.map((value) => _recurseStringify(value)).join(`,`);
  concat += `]`;
  return concat;
};

/** The GraphQL enum type doesn't match to an equivalent in Javascript, so define a class to be used for
 *  passing enum types to stringify.
 */
export function Enum(value) { this.value = String(value).replace(/[^\w]/g, '_'); } // Replace any non-alphanumeric chars with "_".

const _stringifyObject = (object) => {
  // Special-casing for non-object objects.
  if (object === null) { return `null`; }
  if (object instanceof Array) { return _stringifyArray(object); }
  if (object instanceof Enum) { return _stringifyEnum(object); }

  let concat = `{`;
  Object.keys(object).forEach((key, index) => {
    const value = object[key];
    if (value !== undefined) { // Undefined values should just be omitted.
      if (index > 0) { concat += ` `; }
      concat += `${key}:${_recurseStringify(value)}`;
    }
  });
  concat += `}`;
  return concat;
};

const valueTypeToStringifier = {
  'boolean': _stringifyBool,
  'object': _stringifyObject,
  'number': _stringifyNumber,
  'string': _stringifyString,
  'undefined': _stringifyUndefined
};

/** Like JSON.stringify() but concatenates to the slightly different GQL format. */
export const stringify = (value) => {
  const valueType = typeof value;
  const stringifier = valueTypeToStringifier[valueType];
  if (!stringifier) { throw new Error(`Unsupported value type - ${valueType}`); }
  return stringifier(value);
};
_recurseStringify = stringify; // Function pointer to allow circular definition.
